import type { Guide } from '../types';

/**
 * S-21.10-23 — „po oknie” także przy przyjeździe po końcu okna załadunku (C25; scenariusz e2e 22 — reguła w testach
 * jednostkowych). Zlecenia DEMO w horyzoncie rekomendacji nie mają końca okna załadunku, więc kroki pokazują
 * wykonalność, która „po oknie” wtedy mówi. Karta pojazdu — DEMO 001 (rekord pokazowy po numerze rejestracyjnym).
 */
export const guide: Guide = {
  flagKey: 'loadingWindowEnd',
  title: '„Po oknie” także przy przyjeździe po końcu okna załadunku',
  whatItDoes:
    'Rekomendacje sprawdzają teraz także, czy pojazd dojedzie na załadunek przed końcem okna załadunku — dotąd liczył się tylko jego początek. Przyjazd po końcu okna to „po oknie” w wykonalności, przy rekomendowanych pojazdach i przy zleceniach na karcie pojazdu, z powodem w uwagach i w „Na jakiej podstawie”; gdy termin ratują tylko ulgi 561/2006 — „tylko z ulgami”. To szacunek: nikogo nie wyklucza i nie zmienia kolejności, a zlecenie bez końca okna załadunku liczy się jak dotąd.',
  audience: ['planista FTL', 'Team Leader (planista główny)'],
  presentationItems: ['S-21.10-23'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'dowolne zlecenie do zaplanowania w FTL',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', dzial: 'FTL' },
      },
      target: 'feasibility',
      mockupTestId: 'ftl-zlecenie-rekomendacje',
      title: 'Wykonalność przy rekomendowanym pojeździe',
      description:
        'Pod numerem pojazdu: „mieści się”, „ciasny dolot”, „po oknie” albo „brak danych”. „Po oknie” dostaje teraz także pojazd, który według szacunku przyjedzie na załadunek po końcu okna załadunku — dymek mówi, o ile godzin.',
      action: 'Kliknij „Pokaż rekomendowane pojazdy” i najedź na wykonalność pod numerem pojazdu.',
      recorder: {
        account: 'master',
        demo: { kind: 'order', number: 'DEMO/2026/09/001' },
        actions: [{ kind: 'clickButton', name: 'Pokaż rekomendowane pojazdy' }],
      },
    },
    {
      route: '/cars/:carId/show',
      record: { description: 'dowolny pojazd z floty', listPath: '/cars' },
      target: 'feasibility',
      title: 'To samo przy zleceniach na karcie pojazdu',
      description:
        'W „Rekomendowanych zleceniach dla pojazdu” ta sama reguła: zlecenie, na którego załadunek pojazd przyjedzie po końcu okna, ma „po oknie”, a powód stoi w uwagach.',
      action: 'Na karcie pojazdu kliknij „Pokaż rekomendowane zlecenia”.',
      recorder: {
        account: 'ftl',
        demo: { kind: 'car', plate: 'DEMO 001' },
        actions: [{ kind: 'clickButton', name: 'Pokaż rekomendowane zlecenia' }],
      },
    },
  ],
};
